/**
 * ScrollToTop — scroll restoration al cambiar de ruta.
 *
 * Comportamiento:
 *  - Cada vez que cambia `location.pathname`, mueve la ventana a la parte
 *    superior (top: 0, left: 0) de forma **instantánea** (`behavior: 'auto'`).
 *  - Si la URL incluye `hash` (anclas `/ruta#seccion`), respeta el flujo
 *    nativo del browser y NO fuerza arriba — así no rompemos anchors que
 *    quieran hacer scroll a un id específico.
 *  - No se ejecuta en cada render; sólo cuando cambia el pathname o el hash.
 *  - No toca scroll de contenedores internos (modales, drawers, scrollables
 *    con `overflow-auto`): sólo `window`.
 *
 * Uso:
 *  Montar UNA vez dentro de cada layout (`MainLayout`, `AuthLayout`,
 *  `CuentaLayout`, `AdminLayout`). `createBrowserRouter` no permite usar
 *  `useLocation` por fuera de los route elements, así que cada layout es el
 *  punto natural de montaje. Renderiza `null` — no agrega DOM.
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Anclas: dejamos que el browser/el componente target maneje el destino.
    if (hash) return;
    // `behavior: 'auto'` evita animar el salto — el usuario espera ver el
    // tope de la nueva página inmediatamente, sin transición confusa.
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname, hash]);

  return null;
}
